module.exports = __webpack_public_path__ + "img/headphone-2.34ae32ba.svg";